import { List, Create } from "../Components/index.js";

export default [
    {
        path: "/letter/speak",
        component: List,
        name: "letter.speak",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/speak/create",
        component: Create,
        name: "letter.speak.create",
        meta: {
            requiresAuth: true,
        },
    },
    // {path: '/letter/speak/:id/view', component: archiveLetterDetails, name: 'letter.speak.view'},
];
